export const PERSONAL_INFO = {
    name: "Marina Fortes Rey",
    profession: "Tech Lead",
    description: "Fullstack Software developer tech lead with a passion for data visualization. I have worked developing a banking system, where security and consistency were key. I have also worked on a talent acquisition platform, where we had flexibility to bring our own ideas to improve user experience. In the latter, I was quickly promoted to tech lead and helped automate key processes that led to unprecedented company growth.",
    email: "marina.fortes.rey@gmail.com",
    skype: "marina.rey21",
    location: "Porto Alegre, Brazil",
    languages: "English, Portuguese, Spanish, Japanese",
    githubUrl: "https://github.com/marinaFrey",
    linkedInUrl: "https://www.linkedin.com/in/marina-fortes-rey/",
    youtubeUrl: "https://www.youtube.com/channel/UCzQVoboOSU0h7d8HGhuntgw?view_as=subscriber",
    facebookUrl: "https://www.facebook.com/marina.rey.96",
    instagramUrl: "https://www.instagram.com/marina_frey/?hl=en",
    photo: "assets/images/profile.jpg"
}